import { GenericApi } from './generic.api';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IQueryFilter, QueryResult } from '../model/query.filter.class';
import { createUrl, queryToParams } from './api.util';
import { HasId } from '../model/generics';
import { IStore, IStoreOverview, IStorePickup, IStoreProductResponse } from '../model/store.model';
import { ICustomerUser } from '../model/customer.user.model';

type T = IStore;

@Injectable({
  providedIn: 'root'
})
export class StoreApi extends GenericApi<T> {
  public path = "store";

  constructor(
    public httpClient: HttpClient
  ) {
    super(httpClient);
  }

  productList = (query: IQueryFilter): Observable<QueryResult<IStoreProductResponse & HasId<string>>> => {
    return this.httpClient.get<QueryResult<IStoreProductResponse & HasId<string>>>(
      createUrl(this.path, 'all', 'products'),
      {
        params: queryToParams(query)
      }
    );
  };

  employeeList = (query: IQueryFilter): Observable<QueryResult<ICustomerUser & HasId<string>>> => {
    return this.httpClient.get<QueryResult<ICustomerUser & HasId<string>>>(
      createUrl(this.path, 'all', 'user'),
      {
        params: queryToParams(query)
      }
    );
  };

  checkStoreExist(data: { id?: string, name: string }): Observable<{ isExist: boolean }> {
    return this.httpClient.post<{ isExist: boolean }>(
      createUrl(this.path, 'check-store-name'),
      data
    );
  }

  overviewSummary = (storeId: string | null,
  ): Observable<IStoreOverview> => {
    return this.httpClient.get<IStoreOverview>(
      createUrl(this.path, 'dashboard', 'summary'),
      {
        params: storeId ? { storeId: storeId } : {}
      }
    );
  };

  readonly restore = (id: number | string): Observable<{ success: boolean }> =>
    this.httpClient.get<{ success: boolean }>(
      createUrl(this.path, id, "restore"),
      {}
    );
}
